"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceAccordion_1 = require("../../components/ServiceAccordion");
var _globals_1 = require("../_globals");
new ServiceAccordion_1.ServiceAccordion(_globals_1.root);
